.logos {
  max-height: 75px;
}
